import axios, { AxiosInstance } from "axios";
import { URL_PREFIX, URL_PREFIX_V2 } from "./config";

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: URL_PREFIX,
});

export const axiosInstanceV2: AxiosInstance = axios.create({
  baseURL: URL_PREFIX_V2,
});
